var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"float",attrs:{"href":_vm.$router.resolve(_vm.route).href}},[_c('span',{staticClass:"wy-icon-add"})])}
var staticRenderFns = []

export { render, staticRenderFns }